import React from "react";
import { Link } from "react-router-dom";
import { useCategories } from "@/context/SiteContentContext";
import { useBrand } from "@/context/PartnerContext";
import { BrandMark } from "@/components/BrandMark";
import { SupportLinks } from "@/components/SupportLinks";

export const Footer = () => {
  const cats = useCategories();
  const brand = useBrand();
  return (
  <footer className="border-t border-border bg-background">
    <div className="mx-auto max-w-[1400px] px-6 py-12">
      <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
        <div className="col-span-2 md:col-span-1">
          <BrandMark className="h-20" testId="footer-brand-mark" />
          {brand.tagline && <p className="mt-3 max-w-xs text-sm text-muted-foreground" data-testid="footer-tagline">{brand.tagline}</p>}
        </div>
        <div>
          <div className="mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Shop</div>
          <div className="mt-3 flex flex-col gap-2 text-sm">
            <Link to="/how-to-order" data-testid="footer-how-to-order" className="hover:underline">How to Order</Link>
            <Link to="/build-your-box" className="hover:underline">{cats.build.title}</Link>
            <Link to="/multipack-deals" data-testid="footer-custom-order" className="hover:underline">{cats.deals.title}</Link>
            <Link to="/shipping" data-testid="footer-shipping" className="hover:underline">Shipping Policy</Link>
          </div>
        </div>
        <div>
          <div className="mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Payments</div>
          <div className="mt-3 flex flex-wrap gap-2 mono text-xs">
            {["BTC", "LTC"].map((c) => (
              <span key={c} className="border border-border px-2 py-1">{c}</span>
            ))}
          </div>
        </div>
        <div>
          <div className="mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Your Order</div>
          <div className="mt-3 flex flex-col gap-2 text-sm">
            <Link to="/track" data-testid="footer-track" className="hover:underline">Track your order</Link>
            <Link to="/how-to-order" className="hover:underline">How to Order</Link>
          </div>
          <div className="mt-5" data-testid="footer-support">
            <div className="mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Support</div>
            <SupportLinks className="mt-3 flex-col !items-start" />
          </div>
        </div>
      </div>
      <div className="mt-10 border-t border-border pt-6 mono text-[10px] uppercase tracking-[0.15em] text-muted-foreground">
        <span data-testid="footer-copyright">© {new Date().getFullYear()} {brand.name} — No KYC · Crypto Only</span>
      </div>
    </div>
  </footer>
  );
};
